<template>
  <div id="confirm-banner" class="p-text-center">
    <div class="p-text-center">
      {{ $t('confirmBanner', { email: 'example@diamondscheduler.jp' }) }}
      <span @click="resend" style="cursor: pointer; text-decoration: underline;">{{ $t('resendLink') }}</span>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  methods: {
    resend() {
      api
        .resendConfirmationEmail(this.currentUser.email)
        .then(() => this.makeToast("success", this.$t("Toast.resend_comfirmation")));
    },
  },
};
</script>

<style scoped lang="scss">
#confirm-banner {
  width: 100%;
  background: crimson;
  color: white;
  padding: 15px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
}
</style>
